import { memo, useCallback } from 'react';

import { ToolBarProps } from '../ToolBar.types';
import { StyledNormalWrapper, StyledPrimaryWrapper, StyledWrapper } from './Navigation.style';
import { NavItemProps } from './Navigation.types';
import { NavigationButton } from './NavigationButton';

export type NavigationItemProps = NavItemProps;

export type NavigationProps = {
  featuredItem?: NavItemProps;
  items: ToolBarProps['items'];
  activeItem: string | null;
  visible: boolean;
  variant: ToolBarProps['variant'];
  onClick?: (item: NavigationItemProps) => void;
  onCollapse: (isOpen: boolean) => void;
};

export const Navigation = memo(function Navigation({
  featuredItem,
  items,
  activeItem,
  onClick,
  onCollapse,
  variant,
  visible,
}: NavigationProps) {
  const handleCollapse = useCallback(
    (visible: boolean) => {
      if (onCollapse && !visible) {
        onCollapse(visible);
      }
    },
    [onCollapse]
  );

  return (
    <StyledWrapper>
      {featuredItem && (
        <StyledPrimaryWrapper variant={variant}>
          <NavigationButton
            isFeatured={true}
            key={`primary-navigation-${featuredItem.type}-featured`}
            item={featuredItem}
            variant={variant}
            activeItem={activeItem}
            onClick={() => {
              onClick?.(featuredItem);
              handleCollapse(visible);
            }}
          />
        </StyledPrimaryWrapper>
      )}

      <StyledNormalWrapper variant={variant}>
        {items.map((item, index) => (
          <NavigationButton
            key={`normal-navigation-${item.type}-${index}`}
            data-menu-navigation={item.type}
            item={item}
            variant={variant}
            activeItem={activeItem}
            onClick={() => {
              onClick?.(item);
              handleCollapse(visible);
            }}
          />
        ))}
      </StyledNormalWrapper>
    </StyledWrapper>
  );
});
